import Svg from 'components/utilities/svg'

const ArrowIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Arrow Icon</title>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="m5 9 1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z" />
  </Svg>
)

ArrowIcon.displayName = 'Arrow'

export default ArrowIcon
